import { NodeViewWrapper, NodeViewWrapperProps } from '@tiptap/react';
import React, { FC } from 'react';
import cn from 'classnames';
import { DaGifAttrs } from '../gif';
import { getPresetId } from '../../../components/utils/tiptap';
import { EXTENSION_TYPE_NAME } from '../constants';
import { useWidth } from '../hooks/useWidth';
import { useEditorContainerSize } from '../../../components/Editor/Context';
import { cleanLinkSrc } from '../../../components/Viewer/useHandlers';

import viewerStyles from '../Viewer/Viewer.scss';

const GifNodeView: FC<NodeViewWrapperProps> = props => {
  const containerSize = useEditorContainerSize();
  const { editor, extension, node } = props;
  const { options } = extension;
  const attrs: DaGifAttrs = node.attrs;

  const nodeKey = `img-${!attrs.width ? 'default' : 'custom'}`;

  const { width, maxWidth } = useWidth(
    attrs.width,
    options.defaultWidth,
    options.smallMedia,
    attrs.alignment,
    containerSize ?? 0
  );
  const newWidth = Math.min(maxWidth, width ?? options.defaultWidth);
  const height = (newWidth / (attrs.width ?? 0)) * (attrs.height ?? 0);

  return (
    <NodeViewWrapper
      key={nodeKey}
      data-drag-handle="true"
      data-da-type="da-gif"
      data-width={attrs.width}
      data-height={attrs.height}
      data-alignment={attrs.alignment}
      data-url={attrs.url}
      className={cn(
        'draggable-atomic',
        viewerStyles['gif-container'],
        viewerStyles[attrs.alignment],
        options.smallMedia && viewerStyles['small-media'],
        viewerStyles[`preset-${getPresetId(editor)}`]
      )}
    >
      <video
        className={viewerStyles['gif-video']}
        style={{
          pointerEvents: 'none',
        }}
        role="img"
        autoPlay
        muted
        loop
        controlsList="nofullscreen"
        playsInline // required to disable fullscreen iOS
        aria-label="gif"
        data-da-type={EXTENSION_TYPE_NAME}
        width={newWidth}
        height={height}
        src={cleanLinkSrc(attrs?.url || '', ['giphy.com'])}
      ></video>
    </NodeViewWrapper>
  );
};
GifNodeView.displayName = 'GifNodeView';

export default GifNodeView;
